/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React from "react";
// form library
import { Controller, useFormContext } from 'react-hook-form';
// material ui components
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from "@mui/material/Typography";
// custom components
import LeadNumberedHeading from "../../../../shared-components/forms/LeadNumberedHeading";
import NumberedHeading from "../../../../shared-components/forms/NumberedHeading";
import CourseSelect from "./selects/CourseSelect";
import LessonSelect from "./selects/LessonSelect";
import SectionSelect from "./selects/SectionSelect";


function BasicInfoTab(props) {
  const methods = useFormContext();
  const { control, formState } = methods;
  const { errors } = formState;
  const { instance, section } = props;

  return (
    <div>
      <LeadNumberedHeading number="1" title="Basic Information" instructions="This information is used to store details about the page in relation to where it is stored in the module." />

      <Typography variant="subtitle1" className="mb-16 font-semibold">
        Page Location:
      </Typography>

      <Grid container spacing={2} className="mb-32">
        <Grid item xs={12} sm={6} md={4}>
          <NumberedHeading number="1" title="Course" instructions={section?.lesson?.course?.label} />
          <Typography variant="body1" className="mt-16">
            {section?.lesson?.course?.title}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <NumberedHeading number="2" title="Lesson" instructions={section?.lesson?.label} />
          <Typography variant="body1" className="mt-16">
            {section?.lesson?.title}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <NumberedHeading number="3" title="Section" instructions={section?.label} />
          <Typography variant="body1" className="mt-16">
            {section?.title}
          </Typography>
        </Grid>
      </Grid>

      <Typography variant="subtitle1" className="mt-16 font-semibold">
        Page Details:
      </Typography>

      <Grid container spacing={2} className="mb-64">
        <Grid item xs={12} md={8}>
          <NumberedHeading number="4" title="Title" instructions="Enter a title for the template." />
          <Controller
            control={control}
            name="title"
            render={({ field }) => (
              <TextField
                className="mt-16"
                {...field}
                label="Title"
                placeholder="Title"
                id="title"
                error={!!errors.title}
                helperText={errors?.title?.message}
                variant="outlined"
                required
                fullWidth
                size="small"
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <NumberedHeading number="5" title="Page Label" instructions="Enter a label for the page." />
          <Controller
            control={control}
            name="label"
            render={({ field }) => (
              <TextField
                className="mt-16"
                {...field}
                label="Page Label"
                placeholder="Page Label"
                id="label"
                error={!!errors.label}
                helperText={errors?.label?.message}
                variant="outlined"
                required
                fullWidth
                size="small"
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <NumberedHeading number="6" title="Page Number" instructions="Enter a page number." />
          <Controller
            control={control}
            name="screen"
            render={({ field }) => (
              <TextField
                className="mt-16"
                {...field}
                label="Page Number"
                placeholder="Page Number"
                id="screen"
                error={!!errors.screen}
                helperText={errors?.screen?.message}
                variant="outlined"
                required
                fullWidth
                size="small"
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <NumberedHeading number="7" title="Back ID" instructions="Enter previous page number." />
          <Controller
            control={control}
            name="back"
            render={({ field }) => (
              <TextField
                className="mt-16"
                {...field}
                label="Back"
                placeholder="Back"
                id="back"
                error={!!errors.back}
                helperText={errors?.back?.message}
                variant="outlined"
                required
                fullWidth
                size="small"
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <NumberedHeading number="8" title="Next ID" instructions="Enter a next page number." />
          <Controller
            control={control}
            name="next"
            render={({ field }) => (
              <TextField
                className="mt-16"
                {...field}
                label="Next"
                placeholder="Next"
                id="next"
                error={!!errors.next}
                helperText={errors?.next?.message}
                variant="outlined"
                required
                fullWidth
                size="small"
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <NumberedHeading number="9" title="Order" instructions="Enter the order number." />
          <Controller
            control={control}
            name="order"
            render={({ field }) => (
              <TextField
                className="mt-16"
                {...field}
                label="order"
                placeholder="order"
                id="order"
                error={!!errors.order}
                helperText={errors?.order?.message}
                variant="outlined"
                required
                fullWidth
                type="number"
                size="small"
              />
            )}
          />
        </Grid>
      </Grid>
    </div>
  );
}

export default BasicInfoTab;